<template>
  <div class="chat-container">
    <SiteHeader :is_login_page="true"/>
    <!-- 聊天消息区域 -->
    <div class="chat-messages" ref="messagesContainer">
      <div v-for="(message, index) in messages" :key="index" class="message" :class="message.type">
        <div class="message-content">
          <div class="message-text" v-html="message.text"></div>
          <div v-if="message.isLoading" class="loading-indicator">
            <div class="loading-dots">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>
          <div class="message-meta">
            
            <div>
              <button @click="copyMessage(message.text)" class="copy-button" title="复制">
                <svg viewBox="0 0 24 24" width="14px" height="14px">
                  <path d="M19 21H8V7h11m0-2H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m-3-4H4c-1.1 0-2 .9-2 2v14h2V3h12V1z" fill="currentColor"></path>
                </svg>
              </button>
            </div>
            <div>
              <span class="message-time">{{ formatTime(message.time) }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 服务选择区域 -->
      <div class="options-container">
        <div class="options-title">请选择输出类型：</div>
        <div class="radio-group">
          <label v-for="option in serviceOptions" :key="option.value" class="radio-option">
            <input 
              type="radio" 
              v-model="selectedService" 
              :value="option.value" 
              @change="handleServiceSelect"
              :disabled="isLoading"
            />
            <span>{{ option.label }}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-area">
      <div class="input-container">
         <!-- @keyup.enter="isLoading ? abortRequest() : sendMessage()" -->
        <textarea
          rows="6"
          v-model="inputMessage"
          @keyup.enter="isLoading ? abortRequest() : sendMessage()"
          placeholder="输入消息..."
          class="message-input"
          :disabled="isLoading"
        ></textarea>
        <button @click="isLoading ? abortRequest() : sendMessage()" class="send-button">
          <template v-if="isLoading">
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M6 6h12v12H6z" fill="currentColor"></path>
            </svg>
          </template>
          <template v-else>
            <svg viewBox="0 0 24 24" width="20" height="20">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fill="currentColor"></path>
            </svg>
          </template>
        </button>
      </div>
    </div>
    <!-- Toast提示 -->
    <div v-if="showToast" class="toast-message">
      {{ toastMessage }}
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/SiteFooter.vue';
import SiteHeader from '@/components/SiteHeader.vue';

export default {
  components: {
    SiteFooter,
    SiteHeader
  },
  data() {
    return {
      messages: [
        {
          type: 'received',
          text: '您好！我是您的师资助手，有什么可以帮您的吗？',
          time: new Date()
        }
      ],
      inputMessage: '',
      isLoading: false,
      showOptions: false,
      selectedService: '',
      currentStreamingMessage: null,
      abortController: null,
      serviceOptions: [
        { value: 'teacherSearch', label: '师资列表' },
        { value: 'solutionRequest', label: '师资课程推荐' }
      ],
      showToast: false,
      toastTimeout: null,
      toastMessage:""
    };
  },
  methods: {
    ssToast(msg)
    {
      if(this.toastTimeout) clearTimeout(this.toastTimeout);
      this.toastMessage=msg;
      this.showToast = true;
      this.toastTimeout = setTimeout(() => {
        this.showToast = false;
      }, 3000);
      
    },
    sendMessage() {
      
      if (this.inputMessage.trim() === '') 
      {
        this.ssToast("请输入要检索的要求");
        return;
      }
      if (this.isLoading) 
      {
        this.ssToast("正检索请稍候。。。");
        return;
      }
      if (this.selectedService.trim() === '') 
      {
        this.ssToast("请选择输出类型");
        return;
      }
      // 添加用户消息
      this.addMessage('sent', this.inputMessage);
      const userMessage = this.inputMessage;
      this.inputMessage = '';
      
      // 调用API
      this.callTeacherAPI({
        type: this.selectedService,
        question: userMessage
      });
    },
    
    addMessage(type, text) {
      this.messages.push({
        type,
        text,
        time: new Date()
      });
      this.scrollToBottom();
    },
    
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.messagesContainer) {
          this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
        }
      });
    },
    
    formatTime(date) {
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },
    
    handleServiceSelect() {
      // 服务选择逻辑保持不变
    },
    
    async callTeacherAPI(requestData) {
      // 设置加载状态
      this.isLoading = true;
      
      // 创建AbortController以便可以取消请求
      this.abortController = new AbortController();
      
      try {
        // 创建初始接收消息
        this.currentStreamingMessage = {
          type: 'received',
          text: '',
          isLoading: true,
          time: new Date()
        };
        this.messages.push(this.currentStreamingMessage);
        this.scrollToBottom();
        
        // 调用API
        const response = await fetch('https://st.4reasons.cn/api/chat_new/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData),
          signal: this.abortController.signal
        });
        
        if (!response.ok) {
          throw new Error(`API请求失败: ${response.status}`);
        }
        
        // 确保我们处理的是流式响应
        if (!response.body) {
          throw new Error('响应不包含可读流');
        }
        
        // 处理流式响应
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        
        let cc = true
        while (cc) {
          const { done, value } = await reader.read();
          if (done) break;
          
          buffer += decoder.decode(value, { stream: true });
          
          // 处理可能的多条SSE消息
          const parts = buffer.split('\n\n');
          buffer = parts.pop(); // 最后部分可能是不完整的
          
          for (const part of parts) {
            if (!part.startsWith('data: ')) continue;
            
            try {
              const data = JSON.parse(part.slice(6)); // 去掉"data: "
              if (data.content) {
                this.currentStreamingMessage.text += data.content;
                this.scrollToBottom();
              }
            } catch (e) {
              console.error('解析消息失败:', e);
            }
          }
        }
        
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('API调用错误:', error);
          if (this.currentStreamingMessage) {
            this.currentStreamingMessage.text = `请求出错: ${error.message}`;
            this.scrollToBottom();
          }
        }
      } finally {
        if (this.currentStreamingMessage) {
          this.currentStreamingMessage.isLoading = false;
        }
        this.currentStreamingMessage = null;
        this.abortController = null;
        this.isLoading = false;
      }
    },
    
    abortRequest() {
      if (this.abortController) {
        this.abortController.abort();
      }
      if (this.currentStreamingMessage) {
        this.currentStreamingMessage.isLoading = false;
      }
      this.isLoading = false;
    },
    
    copyMessage(text) {
      // 创建一个临时textarea元素
      const textarea = document.createElement('textarea');
      textarea.value = text.replace(/<[^>]*>?/gm, ''); // 去除HTML标签
      textarea.style.position = 'fixed'; // 防止页面滚动
      document.body.appendChild(textarea);
      textarea.select();
      
      try {
        // 执行复制命令
        const successful = document.execCommand('copy');
        if (successful) {
          this.ssToast("已复制到剪贴板");
        }
      } catch (err) {
        console.error('复制失败:', err);
      }
      
      // 移除临时元素
      document.body.removeChild(textarea);
    }
  },
  mounted() {
    this.scrollToBottom();
  },
  beforeUnmount() {
    // 组件销毁时取消所有进行中的请求
    if (this.abortController) {
      this.abortController.abort();
    }
  }
};
</script>

<style scoped>
* { 
  margin: 0; 
  padding: 0; 
  box-sizing: border-box; 
}
body{
  margin:0; 
  padding:0; 
  box-sizing: border-box; 
  background-color: #F5F5F5;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f9f9f9;
}

.chat-messages {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  background-color: #fff;
}

.message {
  display: flex;
  margin-bottom: 12px;
}

.message.sent {
  justify-content: flex-end;
}

.message.received {
  justify-content: flex-start;
}

.message-content {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 18px;
  position: relative;
}

.sent .message-content {
  background-color: #007bff;
  color: white;
  border-bottom-right-radius: 4px;
}

.received .message-content {
  background-color: #f1f1f1;
  color: #333;
  border-bottom-left-radius: 4px;
}

.message-text {
  word-wrap: break-word;
  line-height: 1.4;
  white-space: pre-wrap;
}

.message-meta {
/*  border: 1px solid red;*/
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 4px;
}

.message-time {
/*  border: 1px solid red;*/
  font-size: 0.75rem;
  opacity: 0.8;
  /* 时间自动居左 */
}

.copy-button {
  background: none;
  margin-right: 10px;
  width: 24px;
  height: 24px;
/*  border: 1px solid green;*/
  cursor: pointer;
  padding: 2px;
  opacity: 0.6;
  transition: opacity 0.2s;
  /* 按钮自动居右 */
}

.copy-button:hover {
  opacity: 1;
}

.sent .copy-button {
  color: rgba(255, 255, 255, 0.8);
}

.received .copy-button {
  color: rgba(0, 0, 0, 0.6);
}

.input-area {
  padding: 12px;
  background-color: #fff;
  border-top: 1px solid #eaeaea;
}

.input-container {
  display: flex;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 20px;
  padding: 4px 12px;
}

.message-input {
  flex: 1;
  border: none;
  background: transparent;
  padding: 10px;
  outline: none;
  font-size: 14px;
}

.message-input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.send-button {
  width: 200px;
  background-color: #dddddd;
  border: 1px solid blue;
  cursor: pointer;
  color: #007bff;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.send-button:hover {
  color: #0056b3;
  border: 1px solid #0056b3;
}

.send-button:disabled {
  color: #aaa;
  cursor: not-allowed;
}

.options-container {
  border-radius: 8px;
  padding: 16px;
  margin: 12px 0;
  border: 1px solid #eaeaea;
}

.options-title {
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.radio-group {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.radio-option {
  width: 180px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.radio-option:hover {
  background-color: #e9ecef;
}

.radio-option input {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}

.radio-option span {
  font-size: 16px;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  margin: 12px 0;
}

.loading-dots {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.dot {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: #007bff;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.toast-message {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  z-index: 1000;
  /* animation: fadeInOut 2s ease-in-out; */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* @keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
  20% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
} */
 
.teacher-title{
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 30px;
  font-weight: 500; /* 标题加粗 */
}
.teacher-content{
  font-family: AlibabaPuHuiTi-Regular;
  font-size: 30px;
  font-weight: 300; /* 标题加粗 */
  margin-left: 20px;
}
</style>